import { render, staticRenderFns } from "./FullViewTab.vue?vue&type=template&id=49e45472&scoped=true"
import script from "./FullViewTab.vue?vue&type=script&lang=ts"
export * from "./FullViewTab.vue?vue&type=script&lang=ts"
import style0 from "./FullViewTab.vue?vue&type=style&index=0&id=49e45472&prod&lang=scss"
import style1 from "./FullViewTab.vue?vue&type=style&index=1&id=49e45472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e45472",
  null
  
)

export default component.exports